var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 10.8337H10.8346V15.0003C10.8346 15.4587 10.4596 15.8337 10.0013 15.8337C9.54297 15.8337 9.16797 15.4587 9.16797 15.0003V10.8337H5.0013C4.54297 10.8337 4.16797 10.4587 4.16797 10.0003C4.16797 9.54199 4.54297 9.16699 5.0013 9.16699H9.16797V5.00033C9.16797 4.54199 9.54297 4.16699 10.0013 4.16699C10.4596 4.16699 10.8346 4.54199 10.8346 5.00033V9.16699H15.0013C15.4596 9.16699 15.8346 9.54199 15.8346 10.0003C15.8346 10.4587 15.4596 10.8337 15.0013 10.8337Z",
    fill: "#fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1eecd3afffc8e891e9085d3adafd8350.svg";
export { ForwardRef as ReactComponent };